import { formatDate } from '@btime/helpers'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { RefetchingIndicator } from '../../../../../components/helpers/StatePresenter'
import DataTable from '../../../../../packages/kiti/components/table/DataTable'
import Panel from '../../../../../packages/kiti/components/structure/Panel'
import WebhookCallStatus from './WebhookCallStatus'
import WebhookCallsLoader, { useWebhookCalls } from './_load/WebhookCallsLoader'
import Text from '../../../../../packages/kiti/components/presentation/Text'

const WebhookCallsList = () => {
  const { t } = useTranslation(['webhook', 'common'])
  const calls = useWebhookCalls()

  const columns = [
    {
      label: t('webhook:status'),
      headerSideContent: (
        <>
          <RefetchingIndicator />
        </>
      ),
      dataIndex: 'status',
      flex: 3,
      render: status => <WebhookCallStatus status={status} />
    },

    {
      label: t('webhook:creationDate'),
      dataIndex: 'insertedAt',
      sortIndex: 'INSERTED_AT',
      flex: 3,
      format: formatDate('DD/MM/YY HH:mm')
    },

    {
      label: ' ',
      dataIndex: 'data',
      sortIndex: false,
      flex: 1.5,

      render: (value, record, index, { toggleExpand, isExpanded }) => (
        <Text color="primary" onClick={toggleExpand}>
          {isExpanded ? t('webhook:lessDetails') : t('webhook:moreDetails')}
        </Text>
      ),
      renderExpand: record => (
        <Panel bgColor="light1" noMargin scroll maxWidth={38}>
          <Text>
            <pre>
              <code>{JSON.stringify(record.data, null, 4)}</code>
            </pre>
          </Text>
        </Panel>
      )
    }
  ]

  return <DataTable rowKey="id" columns={columns} data={calls} inPanel size="medium" />
}

const Wrapper = () => (
  <WebhookCallsLoader>
    <WebhookCallsList />
  </WebhookCallsLoader>
)

export default Wrapper
